import {useI18n} from "@/composables/useI18n";
import {isValidDate} from "@/scripts/Validations/Validations";
import moment from "moment/moment";
import {formatDate} from "@/scripts/Common/helpers";
import {DateFormats} from "@/scripts/Common/DateFormats";

const useDateStringLocalization = () => {

    const {
        d,
    } = useI18n();

    const formatDateBasedOnLocalization = (date: string | undefined, mode: 'short' | 'long') => {
        if (!date || date?.length < 0 || !isValidDate(date)) return '';

        return d(moment(date).toDate(), mode);
    }

  const localizeDateString = (date: string, format: string) => {
    const formattedDate = formatDate(date, format);
    return formatDateBasedOnLocalization(formattedDate, 'short');
  }

  /**
   * Localize date time string
   * @param dateTime - date time string
   * @returns string in the format short date and short time, e.g. DD.MM.YY, HH:MM for de-DE or empty string if the date is invalid or not set
   */
  const localizeDateTimeString = (dateTime: string | null | undefined) : string => {
    if(!dateTime) return '';
    const parsedDate = Date.parse(dateTime);
    if (Number.isNaN(parsedDate)) return '';

    return d(parsedDate, {
      dateStyle: 'short',
      timeStyle: 'short'
    });
  };

  /**
   * Localize date only string
   * @param date - date string
   * @returns string in the format short date, e.g. DD.MM.YY for de-DE or empty string if the date is invalid or not set
   */
  const localizeDateOnlyString = (date: string | null | undefined): string => {
    if (!date) return '';
    const parsedDate = Date.parse(date);
    if (Number.isNaN(parsedDate)) return '';

    return d(parsedDate, {
      dateStyle: 'short'
    });
  };

  return {
      formatDateBasedOnLocalization,
      localizeDateString,
      localizeDateTimeString,
      localizeDateOnlyString
  }
}


export {
   useDateStringLocalization
}
